import { render, staticRenderFns } from "./AddGenerarEncomienda.vue?vue&type=template&id=035ab7a0&scoped=true&"
import script from "./AddGenerarEncomienda.vue?vue&type=script&lang=ts&"
export * from "./AddGenerarEncomienda.vue?vue&type=script&lang=ts&"
import style0 from "./AddGenerarEncomienda.vue?vue&type=style&index=0&id=035ab7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ab7a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('035ab7a0', component.options)
    } else {
      api.reload('035ab7a0', component.options)
    }
    module.hot.accept("./AddGenerarEncomienda.vue?vue&type=template&id=035ab7a0&scoped=true&", function () {
      api.rerender('035ab7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/AddGenerarEncomienda.vue"
export default component.exports